import { c as _c } from "react/compiler-runtime";
import { useQuery } from "react-query";
async function fetchWorkosAuthEnabled(): Promise<boolean> {
  const controller = new AbortController();
  let timeout: ReturnType<typeof setTimeout> | undefined;
  const timedOut = new Promise<never>((_, reject) => {
    timeout = setTimeout(() => {
      controller.abort();
      reject(new Error("Auth config request timed out"));
    }, 5000);
  });
  try {
    return await Promise.race([timedOut, (async () => {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/auth/config`, {
        signal: controller.signal
      });
      if (!response.ok) throw new Error("Auth config request failed");
      const data = await response.json();
      return data.workos_auth_enabled === true;
    })()]);
  } finally {
    clearTimeout(timeout);
  }
}
export function useWorkosAuthEnabled() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      retry: false,
      retryOnMount: false,
      staleTime: 60000,
      refetchOnWindowFocus: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    isLoading
  } = useQuery("workosAuthEnabled", fetchWorkosAuthEnabled, t0);
  const t1 = data === true;
  let t2;
  if ($[1] !== isLoading || $[2] !== t1) {
    t2 = {
      workosAuthEnabled: t1,
      isLoading
    };
    $[1] = isLoading;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}